import { CopyrightCircleOutlined } from '@ant-design/icons'
import { Flex, Typography } from 'antd'
import { Link } from 'react-router-dom'

const Footer = () => {
    return (
        <>
            <Flex vertical align='center' style={{ margin: "20px 0" }}>
 
                <Flex gap={5} align='center'>
                    <Typography.Text> All Right Reserved </Typography.Text>
                    <CopyrightCircleOutlined />
                    <Link to="/">
                    <img height={16} src="/image/kamuska.png" alt="Kamuska" />
                    </Link>
                </Flex>

            </Flex>
        </>
    )
}

export default Footer